import { render, staticRenderFns } from "./RuleModal.vue?vue&type=template&id=9fb7921a&scoped=true"
import script from "./RuleModal.vue?vue&type=script&lang=js"
export * from "./RuleModal.vue?vue&type=script&lang=js"
import style0 from "./RuleModal.vue?vue&type=style&index=0&id=9fb7921a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fb7921a",
  null
  
)

export default component.exports